export default __webpack_public_path__ + "static/media/scrapy.a5c1ce2b.svg";